


import { createSlice } from "@reduxjs/toolkit";
import { getNearMiss } from "../reduxApi/nearMissRedusApi";

const NearMissSlice = createSlice({
    name: 'nearmiss',
    initialState: {
        status: 'idel',
        injury: [],
    },
    reducers: {
        deleteNearMissAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.nearmiss.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.nearmiss.splice(index, 1);
                }
            });
        },
        updateNearMisssAction: (state, action) => {
            console.log("action", action.payload.ROWID)
            const index = state.nearmiss.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.nearmiss.splice(index, 1, action.payload)
    
            }
        },
        addNearMissAction: (state, action) => {
            console.log("Adding nearmiss:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.nearmiss.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getNearMiss.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getNearMiss.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing nearmiss Data", action.payload)
                state.nearmiss = action.payload.data.nearMissResp
;
            })
    }
})
export const { deleteNearMissAction, updateNearMisssAction, addNearMissAction } = NearMissSlice.actions
export default NearMissSlice.reducer